var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3467 0.409656C10.1368 0.269698 9.8633 0.269698 9.65336 0.409656L0.278361 6.65966C0.0492002 6.81243 -0.0529454 7.0972 0.0268661 7.3608C0.106678 7.6244 0.349632 7.80469 0.625049 7.80469H2.9688V16.5547H1.87505C1.52987 16.5547 1.25005 16.8345 1.25005 17.1797C1.25005 17.5249 1.52987 17.8047 1.87505 17.8047H18.125C18.4702 17.8047 18.75 17.5249 18.75 17.1797C18.75 16.8345 18.4702 16.5547 18.125 16.5547H17.0313V7.80469H19.375C19.6505 7.80469 19.8934 7.6244 19.9732 7.3608C20.053 7.0972 19.9509 6.81243 19.7217 6.65966L10.3467 0.409656ZM15.4688 7.80469V16.5547H13.9063V7.80469H15.4688ZM12.3438 7.80469V16.5547H10.7813V7.80469H12.3438ZM9.2188 7.80469V16.5547H7.6563V7.80469H9.2188ZM6.0938 7.80469V16.5547H4.5313V7.80469H6.0938ZM10 5.30469C9.30964 5.30469 8.75 4.74504 8.75 4.05469C8.75 3.36433 9.30964 2.80469 10 2.80469C10.6904 2.80469 11.25 3.36433 11.25 4.05469C11.25 4.74504 10.6904 5.30469 10 5.30469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625049 19.0547C0.279871 19.0547 4.85938e-05 19.3345 4.85938e-05 19.6797C4.85938e-05 20.0249 0.279871 20.3047 0.625049 20.3047H19.375C19.7202 20.3047 20 20.0249 20 19.6797C20 19.3345 19.7202 19.0547 19.375 19.0547H0.625049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/Financial.0d348f2e753c31a635cfd562782b48e1.svg";
export { ForwardRef as ReactComponent };